import { useEffect, useState } from "react";
import { PLAYBOOK_CATEGORIES } from "../data/playbook.js";

/**
 * "Kệ sách 5 trạm" ở đầu /playbook, vẽ từ danh sách bài thật.
 * Mỗi trạm là một chồng sách; mỗi bài là một gáy sách: dài theo số phút đọc,
 * màu theo chủ đề. Chạm một chồng là lọc bài của trạm đó (onChon), chạm lại
 * thì bỏ lọc. Sách rơi xuống xếp chồng khi mở trang; HTML prerender đã đủ.
 */
const MAU = ["#86cfaa", "#e9b96e", "#a9bccd", "#d59a86", "#9fb7e0", "#c7d68a", "#e0a7c4", "#7fc4c9", "#f0d28c", "#b3a6d9"];
const mauChuDe = (c) => MAU[Math.max(0, PLAYBOOK_CATEGORIES.indexOf(c)) % MAU.length];

export default function PlaybookKe({ nhom, dangChon, onChon }) {
  const [roi, setRoi] = useState(true);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    setRoi(false);
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setRoi(true)));
    return () => cancelAnimationFrame(id);
  }, []);

  const tongBai = nhom.reduce((a, n) => a + n.posts.length, 0);
  const tongPhut = nhom.reduce((a, n) => a + n.posts.reduce((b, p) => b + (p.readingMinutes || 0), 0), 0);
  const gio = tongPhut >= 60 ? `khoảng ${Math.round(tongPhut / 60)} giờ đọc` : `${tongPhut} phút đọc`;

  return (
    <div className={`pbk${roi ? " roi" : ""}`}>
      <div className="pbk-dau">
        <span>{tongBai} bài theo {nhom.filter((n) => n.so).length} trạm</span>
        <span className="pbk-goi-y">Chạm để lọc</span>
      </div>
      <div className="pbk-ke" role="group" aria-label="Lọc bài theo trạm">
        {nhom.map((n, ci) => (
          <button
            key={n.id}
            type="button"
            className={dangChon === n.id ? "dang" : dangChon ? "mo" : ""}
            aria-pressed={dangChon === n.id}
            disabled={!n.posts.length}
            onClick={() => onChon(dangChon === n.id ? "" : n.id)}
            aria-label={`${n.so ? `Trạm ${n.so}: ` : ""}${n.ten}, ${n.posts.length} bài`}
          >
            <span className="pbk-chong" aria-hidden="true">
              {n.posts.map((p, i) => (
                <i
                  key={p.slug}
                  style={{
                    "--w": `${Math.min(100, 58 + (p.readingMinutes || 5) * 3)}%`,
                    "--l": `${(i * 7 + ci * 3) % 14}%`,
                    "--m": mauChuDe(p.category),
                    "--d": `${ci * 70 + i * 55}ms`,
                  }}
                />
              ))}
            </span>
            <span className="pbk-ten">
              <b>{n.so ? `Trạm ${n.so}` : n.ten}</b>
              <small className="pbk-ten-dai">{n.so ? n.ten : "Chưa gắn trạm"}</small>
              <small>{n.posts.length} bài</small>
            </span>
          </button>
        ))}
      </div>
      <p className="pbk-chan"><b>{tongBai}</b> bài, {gio}. Mỗi gáy sách là một bài, màu theo chủ đề</p>
    </div>
  );
}
